import { useDelay } from '@10000/react'
import { Body, Box } from '.'

export const TextSpinner = ({ items, selectedIndex, size = 36, delay = 10, duration = 2, ...props }) => {
  const scroll = useDelay(delay)
  const top = scroll ? -selectedIndex * 50 : 0

  return (
    <Box
      column
      height={size}
      overflowY="hidden"
      alignItems="center"
      {...props}
    >
      {items.map((item, i) =>
        <Box
          container
          key={i}
          height={50}
          minHeight={50}
          top={top}
          transition={`${duration}s ease-out`}
        >
          <Body alt bold size={size} lineHeight={1.1}>
            {item}
          </Body>
        </Box>
      )}
    </Box>
  )
}